class Accordion {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    $(".js-acc-trigger").on("click", function() {
      $(this).find(".js-acc-plus").toggleClass("is-active");
      $(this).next().slideToggle();
    });
  }
}